import axios from 'axios';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import Tagify from '@yaireo/tagify';
import Swal from 'sweetalert2';
import { Bus } from './bus';
import { gtmEvent } from './services/gtm';

import '@yaireo/tagify/dist/tagify.css';

window.addEventListener('load', () => {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('a[data-log-and-redirect]')?.addEventListener('click', async (e) => {
      e.preventDefault();

      const url = this.getAttribute('href');
      const message = this.getAttribute('data-log-and-redirect');

      try {
        await window.axios.post('/activity_log', { message });
        // eslint-disable-next-line no-empty
      } catch (error) {
        console.error(error);
      }

      window.location.href = url;
    });
  });
});

const toggleModal = () => {
  document.querySelector('.js-modal').classList.toggle('hidden');
  document.querySelector('body').classList.toggle('overflow-hidden');
};

document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.menu-toggle')?.addEventListener('click', () => {
    document.querySelector('.header-menu').classList.toggle('-translate-x-full');
    document.querySelector('.header-menu').classList.toggle('translate-x-0');
    document.getElementById('app').classList.toggle('overflow-hidden');
    document.querySelector('.overlay').classList.toggle('hidden');
    document.querySelector('.overlay').classList.toggle('flex');
  });

  document.querySelector('.overlay')?.addEventListener('click', () => {
    document.querySelector('.header-menu').classList.toggle('-translate-x-full');
    document.querySelector('.header-menu').classList.toggle('translate-x-0');
    document.getElementById('app').classList.toggle('overflow-hidden');
    document.querySelector('.overlay').classList.toggle('hidden');
    document.querySelector('.overlay').classList.toggle('flex');
  });

  document.querySelector('.js-modal .backdrop')?.addEventListener('click', () => {
    toggleModal();
  });

  document.querySelector('.js-join-us-button')?.addEventListener('click', () => {
    // eslint-disable-next-line no-script-url
    if (this.getAttribute('href') === 'javascript:void(0);') {
      toggleModal();
    }
  });

  document.querySelector('.js-dataLayer-event')?.addEventListener('click', async () => {
    gtmEvent(this.getAttribute('data-gaEvent'), {
      ga_category: this.getAttribute('data-gaCategory'),
      ga_action: this.getAttribute('data-gaAction'),
      ga_event: this.getAttribute('data-gaEvent'),
      ga_label: this.getAttribute('data-gaLabel'),
      ga_value: this.getAttribute('data-gaValue'),
    });
  });

  setTimeout(() => {
    const classes = document.querySelector('.js-messenger-bubble')?.classList;

    classes?.remove('hidden');
    classes?.add('bounceIn');
  }, 1000);

  if (document.querySelectorAll('.js-interests-tags').length > 0) {
    // eslint-disable-next-line no-new
    new Tagify(document.querySelector('input.js-interests-tags'), {
      whitelist: [
        'Fashion',
        'Food',
        'Beverage',
        'Beauty',
        'Athletic / Fitness',
        'Sports',
        'Kids / Parents',
        'Travel',
        'Music',
        'Healthy Living',
        'Tech / Gaming',
        'LGBTQ',
        'Outdoor',
        'Interior design',
      ],
      maxTags: 10,
      dropdown: {
        maxItems: 20, // <- mixumum allowed rendered suggestions
        classname: 'tags-look', // <- custom classname for this dropdown, so it could be targeted
        enabled: 0, // <- show suggestions on focus
        closeOnSelect: false, // <- do not hide the suggestions dropdown once an item has been selected
      },
    });
  }

  function getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  if (
    document.querySelectorAll('.js-holiday-video-modal').length > 0 &&
    !getCookie('visitedOnChristmas') &&
    !getCookie('visitedOnNY')
  ) {
    document.cookie = 'visitedOnChristmas=true; expires=31 Dec 2020 12:00:00 UTC';
    document.cookie = 'visitedOnNY=true; expires=5 Jan 2021 12:00:00 UTC';

    const title = '<div class="text-xl font-montserrat">Happy Holidays</div>';
    const html = `<div style="padding:56.25% 0 0 0;position:relative;">
      <iframe src="https://player.vimeo.com/video/494085390?autoplay=1&muted=1&color=b4b4b4" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen>
      </iframe>
    </div>`;

    Swal.fire({
      title,
      html,
      showConfirmButton: false,
      showCloseButton: true,
      width: '850px',
      background: '#fffafa',
      showClass: {
        popup: 'swal2-noanimation',
        backdrop: 'swal2-noanimation',
      },
    });
  }
});

window.loadImage = (event, containerClass) => {
  const container = document.querySelector(containerClass);
  container.style.display = 'block';
  container.src = URL.createObjectURL(event.target.files[0]);
  container.onload = () => {
    URL.revokeObjectURL(container.src);
  };
};

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Add a response interceptor
window.axios.interceptors.response.use(
  (response) => {
    if (response.data) {
      if (response.data && response.data.alert && isObject(response.data.alert)) {
        Bus.$emit('alert', response.data.alert);
      }
      if (response.data && response.data.message && isString(response.data.message)) {
        Bus.$emit('alert', response.data.message);
      }
      if (response && response.data && response.data.redirect_url && isString(response.data.redirect_url)) {
        setTimeout(() => {
          window.location.href = response.data.redirect_url;
        }, 2000);
      }
    }

    return response;
  },
  (error) => {
    if (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.redirect_url &&
        isString(error.response.data.redirect_url)
      ) {
        window.location.href = error.response.data.redirect_url;
      }

      if (error.response && error.response.data && isObject(error.response.data)) {
        Bus.$emit('error', error.response.data);
      }

      if (
        error.response &&
        error.response.data &&
        error.response.data.message &&
        isString(error.response.data.message)
      ) {
        Bus.$emit('error', error.response.data.message);
      }

      if (axios.isCancel(error)) {
        return error.message;
      }
    }

    return Promise.reject(error);
  },
);
